module.exports = __webpack_public_path__ + "img/DCIImg03.ce76fa69.png";